import React from 'react';

const Blog = () => {
    return (
        <div className='w-10/12 max-w-[700px] mx-auto py-10 grid grid-cols-1 gap-6 '>
            {/* Question 1 */}
            <div tabIndex={0} className="collapse collapse-plus border border-base-300 bg-base-100  shadow-lg rounded">
                <div className="collapse-title text-xl  rounded font-medium  bg-blue-800 text-white">
                What is the purpose of react router ?
                </div>
                <div className="collapse-content ">
                    <p>React Router is a library in React for routing. It enables the access the website URL, allows changing the browser URL, and keeps the UI in sync with the URL.React Router gives routing features without reload website or page.It keeps track of the location and renders different componets who define into the router.It allows the creation of single-page web or mobile apps that allows navigation without the page refreshing.</p>
                </div>
            </div>
            {/* Question 2  */}
            <div tabIndex={1} className="collapse collapse-plus border border-base-300 bg-base-100 rounded shadow-lg">
                <div className="collapse-title text-xl rounded font-medium bg-blue-800 text-white">
                How does Context API works ?
                </div>
                <div className="collapse-content">
                    <p>The Context API is a component structure provided by the React framework, which enables us to share specific forms of data across all levels of the application. It's aimed at solving the problem of prop drilling.The Context API is useful for sharing data that can be considered global, such as the currently authenticated/ targeted user.The Context API makes it easier to have our global and app-wide data available to all components therefore, making it easier and more accessible.We can wrap child components in the Context Provider and supply the state value.</p>
                </div>
            </div>
             {/* Question 3  */}
             <div tabIndex={1} className="collapse collapse-plus border border-base-300 bg-base-100 rounded shadow-lg">
                <div className="collapse-title text-xl rounded font-medium bg-blue-800 text-white">
                What is useRef ?
                </div>
                <div className="collapse-content">
                    <p><b>useRef</b> is a react hook and is mainly used for creating a reference of the DOM element or directly accessing it inside a functional component.We can use the ref attribute to access the DOM API. We can get the value of an input element and, at the same time, trigger methods like a focus() with it.It's look like a "Box" that can hold a mutable data/value.The useRef Hook allows you to persist values between renders.The useRef() only returns one item.  </p>
                </div>
            </div>
        </div>
    );
};


export default Blog;